define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/CopyController",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/reflection",
	"csi/resolver",
	"csi/session",
	"csi/xml"
], function(declare, lang, CopyController, Field, Relationship, reflection, resolver, session, xml) {

	return declare(CopyController, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: if current node has parent, then add parent field to specify new parent
			var node = this.getNode();
			var nodeParent = this.getParent();
			var rcr = reflection.getRelationBetweenNodes(node, nodeParent, true);
			if (rcr) {
				view.insertField(lang.mixin(new Field(), {
					bForceEditable: true,
					m_id: xml.ATTR_PARENT,
					m_bRequired: true,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: nodeParent.$Type
					})
				}), 0, true);

				view.addDefaultValue(xml.ATTR_PARENT, nodeParent.$URL);
				this.m_relation = rcr;
				this.m_idAttrParent = rcr.getId();
			}

			this.inherited(arguments);
		},

		onValidate() {
			// summary: need to validate that user has access on destination parent
			if (this.m_idAttrParent) {
				this.m_urlParent = this.m_formData.getFieldValue(xml.ATTR_PARENT, true);

				if (xml.isValidURL(this.m_urlParent)) {
					var nodeParent = resolver.resolveNode(this.m_urlParent, true);
					if (nodeParent) {
						if (!xml.nodeHasAccess(nodeParent, this.m_action.m_rightParent, this.m_idAttrParent) || !xml.nodeHasRight(nodeParent, this.m_action.m_rightParentBase)) {
							throw new Error(this.getError("_ErrorAccess"));
						}
					}
				}
			}
		},

		postProcessSuccess: function() {
			// summary: navigate to new node
			session.setLocationUrl(this.m_urlNode, true);
		}
	});
});